<template>
	<div>
		<v-dialog v-model="dialog_nature" no-click-animation scrollable persistent max-width="300px" transition="dialog-bottom-transition">
	      <v-card>
	        <v-card-title noshadow class="dialog_searchbox">
	        	<v-subheader full-width>Select Nature</v-subheader>
	        </v-card-title>
	        <v-divider></v-divider>
	        <v-card-text nopadding single-selection-dialog>

	        	<v-list nopadding>
		        	<v-list-tile v-for="(item, index) in natureList" :key="index" @click="updateNature(item)">

			            <v-list-tile-content>
			              <v-list-tile-title>{{item.title}}</v-list-tile-title>
			            </v-list-tile-content>

			            <v-list-tile-action>
					        <v-icon v-if="item.id == selectedNature">radio_button_checked</v-icon>
					        <v-icon v-else>radio_button_unchecked</v-icon>
			            </v-list-tile-action>

		        	</v-list-tile>
		        </v-list>

	          	<!-- <v-radio-group column form-item v-model="$parent.Form.nature" full-width-label right-align-radio>
	          		<v-radio :label="item.title" :value="item.id" v-for="(item, index) in nature" :key="index" @change="fn_updateNature(item)"></v-radio>
	          	</v-radio-group> -->
	        </v-card-text>
	        <v-divider></v-divider>
	        <v-card-actions>
	        	<v-spacer></v-spacer>
	          <v-btn color="blue darken-1" flat @click.native="$parent.fn_closeDialogWeb">close</v-btn>
	        </v-card-actions>
	      </v-card>
	    </v-dialog>
	</div>
</template>

<script>
	export default{
		props:['natureList', 'selectedNature', 'updateNature'],
		data(){
			return{
				dialog_nature: false
			}
		},
		methods:{
			openDialogWeb: function () {
				this.dialog_nature = true;
			},
			closeDialogWeb: function () {
				this.dialog_nature = false;
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/masters/forms/account_groups/dialogs/dialog_nature.vue